<template>
  <div>
    <div>
      <el-button class="printBtn" type="primary" style="margin: 2mm 0 0 2mm" @click="printHandle">打印</el-button>
    </div>
    <div v-loading="contentLoading" id="print">
      <div class="printItem" v-for="(item, index) in data" :key="index">
        <table cellpadding="0" cellspacing="0">
          <tr>
            <td rowspan="4" style="width: 100px">
              <div :id="'qrCode' + item.jsonStr" align="center" />
            </td>
            <td>{{ wareHouseInfo.warehouseNo }}</td>
          </tr>
          <tr>
            <td>{{ wareHouseInfo.warehouseName }}</td>
          </tr>
          <tr v-if="item.newNumber">
            <td>{{ item.newNumber }}</td>
          </tr>
          <tr v-if="item.newName">
            <td>{{ item.newName }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      data: [],
      wareHouseInfo: {
        warehouseNo: "",
        warehouseName: "",
      },
      contentLoading: false,
    };
  },

  mounted() {
    this.wareHouseInfo = JSON.parse(this.$route.query.params);
    this.getLocations(this.wareHouseInfo.warehouseNo);
  },

  methods: {
    // 根据仓库编号查询仓位信息
    getLocations(warehouseNo) {
      this.contentLoading = true;
      this.$http
        .get("basic", `warehouseLocations/kingdee?warehouseNo=${warehouseNo}`)
        .then((res) => {
          if (res.success) {
            if (res.data.flexName.length) {
              res.data.data.forEach((item) => {
                item.newName = this.getStr(item, "name");
                item.newNumber = this.getStr(item, "number");
                item.jsonStr = JSON.stringify({
                  warehouseNo: this.wareHouseInfo.warehouseNo,
                  warehouseName: this.wareHouseInfo.warehouseName,
                  locationNo: item.newNumber,
                  locationName: item.newName,
                });
              });
              this.data = res.data.data;
            } else {
              let obj = {
                warehouseNo: this.wareHouseInfo.warehouseNo,
                warehouseName: this.wareHouseInfo.warehouseName,
                locationNo: "",
                locationName: "",
              };
              this.$set(this.data, 0, {
                jsonStr: JSON.stringify(obj),
              });
            }
            for (let item of this.data) {
              this.$nextTick(() => {
                document.getElementById("qrCode" + item.jsonStr).innerHTML = "";
                this.bindQRCode(item.jsonStr);
              });
            }
          }
          this.contentLoading = false;
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },

    // js对象数组种的某属性值拼接成字符串
    getStr(arr, name) {
      let str = arr
        .map(function (obj, index) {
          return obj[name];
        })
        .join(",");
      return str;
    },

    bindQRCode(code) {
      new QRCode(document.getElementById("qrCode" + code), {
        text: code,
        width: 95,
        height: 95,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },

    printHandle() {
      document.body.innerHTML = document.getElementById("print").parentNode.innerHTML;
      window.print();
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.printItem {
  width: 76mm;
  height: 36mm;
  border: 0.5mm solid #666;
  border-bottom: none;
  page-break-after: always;
  margin-top: 1.5mm;
  margin-left: 2mm;
  display: inline-block;
  font-size: 10px;
  table {
    width: 100%;
    height: 100%;
    tr {
      td {
        border-bottom: 0.5mm solid #666;
        border-right: 0.5mm solid #666;
        padding: 0 5px;
        &:last-child {
          border-right: none;
        }
      }
    }
  }
}

@media print {
  .printBtn {
    display: none;
  }
}
</style>
